import { render, staticRenderFns } from "./ComboFonte.vue?vue&type=template&id=6118ec36"
import script from "./ComboFonte.vue?vue&type=script&lang=ts"
export * from "./ComboFonte.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports